import React, { useContext, useState } from "react";
import { AppContext } from "../context/AppContext";
import { FaSpinner } from "react-icons/fa";

function UploadChallan() {
  const [file, setFile] = useState(null); // Store the selected file
  const { loginUserEmail } = useContext(AppContext); // Assuming email is provided by context
  const [loading, setLoading] = useState(false); // Add loading state
  const [fileError, setFileError] = useState(""); // Error state for file validation

  // Function to show toast notifications
  const showToast = (type, message) => {
    const toast = document.createElement("div");
    toast.className = `fixed top-4 right-4 flex items-center w-full max-w-xs p-4 mb-4 text-gray-500 bg-white rounded-lg shadow dark:text-gray-400 dark:bg-gray-800 ${
      type === "success"
        ? "text-green-500 bg-green-100 dark:bg-green-800 dark:text-green-200"
        : "text-red-500 bg-red-100 dark:bg-red-800 dark:text-red-200"
    }`;
    toast.innerHTML = `
      <div class="inline-flex items-center justify-center flex-shrink-0 w-8 h-8 ${
        type === "success"
          ? "text-green-500 bg-green-100 dark:bg-green-800 dark:text-green-200"
          : "text-red-500 bg-red-100 dark:bg-red-800 dark:text-red-200"
      } rounded-lg">
        <svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
          ${
            type === "success"
              ? `<path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />`
              : `<path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 11.793a1 1 0 1 1-1.414 1.414L10 11.414l-2.293 2.293a1 1 0 0 1-1.414-1.414L8.586 10 6.293 7.707a1 1 0 0 1 1.414-1.414L10 8.586l2.293-2.293a1 1 0 0 1 1.414 1.414L11.414 10l2.293 2.293Z" />`
          }
        </svg>
      </div>
      <div class="ml-3 text-sm font-normal">${message}</div>
    `;
    document.body.appendChild(toast);

    // Automatically remove toast after 3 seconds
    setTimeout(() => toast.remove(), 3000);
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFileError("");

    if (selectedFile) {
      // Check if the file is an image
      if (!selectedFile.type.match("image.*")) {
        setFileError("Please select an image file (JPEG, PNG, GIF, etc.)");
        setFile(null);
        return;
      }

      setFile(selectedFile);
    }
  };

  const handleSubmit = async () => {
    if (!file) {
      showToast("error", "No image selected");
      return;
    }

    // Set loading to true before starting the request
    setLoading(true);

    // Create a FormData object to send the file and email
    const formData = new FormData();
    formData.append("file", file); // Append the file to FormData
    formData.append("email", loginUserEmail); // Append the email to identify the student

    // Get the Bearer token from localStorage (or context if using context)
    const token = localStorage.getItem("token");

    if (!token) {
      showToast("error", "Authorization token missing.");
      setLoading(false); // Reset loading state
      return; // Stop if token is not found
    }

    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const response = await fetch(`${apiUrl}/fees/upload-fee-voucher`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`, // Add the token to the request headers
        },
        body: formData, // The FormData containing the file and email
      });

      if (response.ok) {
        const data = await response.json();
        showToast("success", "Image uploaded successfully");
      } else {
        console.error("Image upload failed");
        showToast("error", "Image upload failed");
      }
    } catch (err) {
      console.error("Error:", err);
      showToast("error", "An error occurred. Please try again");
    } finally {
      // Set loading to false after the request completes (whether success or error)
      setLoading(false);
    }
  };

  // Button loading spinner component
  const ButtonSpinner = () => <FaSpinner className="animate-spin mr-2" />;

  return (
    <div className="max-w-7xl mx-auto bg-white shadow-md rounded-lg p-6">
      <h3 className="bg-blue-800 text-white text-lg font-semibold px-4 py-3 rounded-t">
        Manage Application
      </h3>

      <label
        className="block text-gray-600 text-sm font-medium mb-2 mt-4"
        htmlFor="file-upload"
      >
        Upload Fee Voucher Image <span className="text-red-500">*</span>
      </label>

      <div className="flex flex-col space-y-2 mb-4">
        <input
          type="file"
          id="file-upload"
          className="w-full p-2 border border-gray-300 rounded-md"
          onChange={handleFileChange}
          accept="image/*"
          disabled={loading}
        />
        {fileError && <p className="text-red-500 text-sm">{fileError}</p>}
      </div>

      {/* Centered Upload button with loading state */}
      <div className="flex justify-center mb-4">
        <button
          onClick={handleSubmit}
          disabled={loading || !file}
          className={`px-4 py-2 rounded-md flex items-center justify-center transition-colors duration-300 ${
            loading
              ? "bg-blue-400 cursor-wait"
              : !file
              ? "bg-gray-300 text-gray-500 cursor-not-allowed"
              : "bg-blue-500 hover:bg-blue-600 text-white"
          }`}
        >
          {loading ? (
            <>
              <ButtonSpinner /> Uploading...
            </>
          ) : (
            "Upload"
          )}
        </button>
      </div>
    </div>
  );
}

export default UploadChallan;
